/* eslint-disable no-underscore-dangle */
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { ReactComponent as M4 } from '../../../../Asset/svg/matching4.svg';
import { useHistory } from 'react-router-dom';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { useMemo } from 'react';
import { filter, map } from 'lodash';

interface IMatching {
  data: any;
  linkEbook?: string;
  linkResultTest?: string;
  dataFromEbook?: any;
  dataFromJob?: any;
}

const MatchingTalent = (props: IMatching) => {
  const classes = useStyles();
  const { data, linkEbook, linkResultTest, dataFromEbook, dataFromJob } = props;
  const history = useHistory();

  const soft_skills_values: { [key: string]: string } = {
    'résolution de problèmes': 'problem_solving',
    confiance: 'confidence',
    'intelligence émotionnelle': 'emotional_intelligence',
    empathie: 'empathy',
    communication: 'communication',
    'gestion du temps': 'time_management',
    'gestion du stress': 'stress_management',
    créativité: 'creativity',
    'esprit d’entreprendre': 'entrepreneurial_spirit',
    audace: 'daring',
    automotivation: 'motivation',
    vision: 'vision',
    présence: 'presence',
    'sens du collectif': 'collective_sense',
    curiosité: 'curiousity',
    'esprit critique': 'critical_mind',
  };

  const { talent, talentProfil } = useMemo(() => {
    return {
      talent: data?._data?.softSkills?.job || [],
      talentProfil: data?._data?.softSkills?.candidat || [],
    };
  }, [data]);

  const { infoTools, dataLangage } = useMemo(() => {
    return {
      infoTools: dataFromEbook?.softwareTools ? JSON.parse(dataFromEbook.softwareTools) : [],
      dataLangage: dataFromEbook?.langage || [],
    };
  }, [dataFromEbook]);

  const langages = useMemo(() => {
    const langFromJob = filter(
      dataFromJob?.hard_skills_languages,
      (value, key) => !key?.includes('Niveau')
    );
    return map(langFromJob, (value, key) => value) || [];
  }, [dataFromJob]);

  return (
    <div className={classes.containerMatch}>
      <Grid container={true} alignItems="center" justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <M4 style={{ width: 30, height: 33, marginRight: 15 }} />
          <Typography className={classes.matchTitle}>
            Matching <span>Talents</span>
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          {data?.isComplete && (
            <CircularProgressCustom
              value={Math.round(data?.totalPercent || 0)}
              color="#BC72A7"
              size={40}
              fontSize={12}
              fontSizeFloat={12}
              isPercent={true}
            />
          )}
        </Grid>
      </Grid>
      {/* 16 soft skills Harmony® */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Test des 16 soft skills Harmony®</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            disabled={linkResultTest === ''}
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => history.push(linkResultTest as string)}>
            Accès résultats
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* body */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px solid #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              {talent[0] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={8}
          style={{
            borderTop: '1px solid #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {`${talentProfil[soft_skills_values[talent[0]]] || 'NC'}/100`}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              {talent[1] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={8}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {`${talentProfil[soft_skills_values[talent[1]]] || 'NC'}/100`}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              {talent[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={8}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {`${talentProfil[soft_skills_values[talent[2]]] || 'NC'}/100`}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              {talent[3] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={8}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {`${talentProfil[soft_skills_values[talent[3]]] || 'NC'}/100`}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              {talent[4] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={8}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleMatch}>
              {`${talentProfil[soft_skills_values[talent[4]]] || 'NC'}/100`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* 16 soft skills Harmony® */}

      <div className={classes.separator} />

      {/* Autoévaluation Hard skills */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Autoévaluation Hard skills</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkEbook && history.push(linkEbook as string)}>
            Accès ebook
          </Button>
        </Grid>
      </Grid>
      <Grid
        style={{
          marginTop: 20,
        }}
        container={true}
        item={true}>
        {/* body 1 */}
        <Grid
          item={true}
          lg={4}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderTop: '1px dashed #5E65A3',
            borderRight: '1px dashed #5E65A3',
            marginBottom: 20,
            borderBottomLeftRadius: 5,
            borderTopLeftRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Langues parlées
            </Typography>
          </div>
        </Grid>
        <Grid item={true} container={true} lg={8} style={{ marginBottom: 20 }}>
          <Grid
            item={true}
            lg={6}
            style={{
              borderBottom: '1px solid #5E65A3',
              borderRight: '1px solid #5E65A3',
              borderTop: '1px solid #5E65A3',
            }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {langages[0] || 'NC'}
              </Typography>
            </div>
          </Grid>
          <Grid
            item={true}
            lg={6}
            style={{
              borderBottom: '1px solid #5E65A3',
              borderTop: '1px solid #5E65A3',
              borderRight: '1px solid #5E65A3',
              borderTopRightRadius: 5,
            }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleMatch}>
                {dataLangage[langages[0]] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {langages[1] || 'NC'}
              </Typography>
            </div>
          </Grid>
          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleMatch}>
                {dataLangage[langages[1]] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {langages[2] || 'NC'}
              </Typography>
            </div>
          </Grid>
          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleMatch}>
                {dataLangage[langages[2]] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {langages[3] || 'NC'}
              </Typography>
            </div>
          </Grid>
          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleMatch}>
                {dataLangage[langages[3]] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={6}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {langages[4] || 'NC'}
              </Typography>
            </div>
          </Grid>
          <Grid
            item={true}
            lg={6}
            style={{
              borderBottom: '1px solid #5E65A3',
              borderRight: '1px solid #5E65A3',
              borderBottomRightRadius: 5,
            }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleMatch}>
                {dataLangage[langages[4]] || 'NC'}
              </Typography>
            </div>
          </Grid>
        </Grid>
        {/* body 1 */}

        {/* body 2 */}
        <Grid
          item={true}
          lg={4}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderTop: '1px dashed #5E65A3',
            borderRight: '1px dashed #5E65A3',
            borderBottomLeftRadius: 5,
            borderTopLeftRadius: 5,
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Logiciels maîtrisés
            </Typography>
          </div>
        </Grid>
        <Grid item={true} container={true} lg={8}>
          <Grid
            item={true}
            lg={12}
            style={{
              borderBottom: '1px solid #5E65A3',
              borderTop: '1px solid #5E65A3',
              borderRight: '1px solid #5E65A3',
              borderTopRightRadius: 5,
            }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {infoTools[0] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={12}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {infoTools[1] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={12}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {infoTools[2] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={12}
            style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {infoTools[3] || 'NC'}
              </Typography>
            </div>
          </Grid>

          <Grid
            item={true}
            lg={12}
            style={{
              borderBottom: '1px solid #5E65A3',
              borderRight: '1px solid #5E65A3',
              borderBottomRightRadius: 5,
            }}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                {infoTools[4] || 'NC'}
              </Typography>
            </div>
          </Grid>
        </Grid>
        {/* body 2 */}
      </Grid>
      {/* Autoévaluation Hard skills */}
    </div>
  );
};

export default MatchingTalent;
